<template>
  <div>
    <div class="mb-3">
      <div>
        <UInputMenu
          v-model="selected"
          v-model:query="model.address"
          :search="search"
          :loading="loading"
          :debounce="500"
          placeholder="Find address..."
          trailing
          trailing-icon="i-heroicons-map-pin"
          by="formattedAddress"
          size="lg"
          class="z-20 mb-3"
          @input="input = true"
        >
          <template #option="{ option: address }">
            <span>{{ address.formattedAddress }}</span>
          </template>
        </UInputMenu>

        <div id="address-autocomplete-tag" />
      </div>

      <UInput v-model="model.address2" :disabled="props.disabled" size="lg" />
    </div>

    <div class="sm:flex sm:items-start sm:space-x-3  rtl:space-x-reverse mb-3">
      <UFormGroup :label="$t('general.suburb')" class="w-full sm:w-1/2">
        <UInput v-model="model.suburb" :disabled="props.disabled" size="lg" />
      </UFormGroup>

      <UFormGroup :label="$t('general.city')" class="w-full sm:w-1/2">
        <UInput v-model="model.city" :disabled="props.disabled" size="lg" />
      </UFormGroup>
    </div>
    
    <div class="sm:flex sm:items-start sm:space-x-3  rtl:space-x-reverse mb-3">
      <UFormGroup :label="$t('general.region')" class="w-full sm:w-1/2">
        <UInput v-model="model.region" :disabled="props.disabled" size="lg" />
      </UFormGroup>

      <UFormGroup :label="$t('general.postcode')" class="w-full sm:w-1/2">
        <UInput v-model="model.postcode" :disabled="props.disabled" size="lg" />
      </UFormGroup>
    </div>

    <div class="sm:flex sm:items-start sm:space-x-3  rtl:space-x-reverse mb-8">
      <UFormGroup :label="$t('general.country')" class="w-full sm:w-1/2">
        <UInput v-model="model.country" :disabled="props.disabled" size="lg" />
      </UFormGroup>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'BAddress'
}
</script>

<script setup lang="ts">
import Radar from 'radar-sdk-js';

import type { ModelRef } from 'vue';
import type { User } from '@@/types/user';

const radar_test_key = 'prj_test_pk_7d0b8d3107d27df9fb890c5141faeb27f218a146'
const radar_live_key = 'prj_live_pk_352457a5eebd2c0766f55e0d63071d96c36a082e'

Radar.initialize(process.env.NODE_ENV === 'development' ? radar_test_key : radar_live_key);

const model: ModelRef<User | undefined> = defineModel({
  required: true
})

const props = defineProps<{
  disabled: boolean
}>()

const loading = ref(false)
const selected = ref()
const input = ref(false)

async function search (q: string) {
  if (!input.value) {
    return []
  }

  loading.value = true

  if (!q || q.length < 3) {
    loading.value = false
    return []
  }

  try {
    const result = await Radar.autocomplete({
      query: q,
      limit: 5
    })

    loading.value = false

    return result?.addresses || []
  } catch (e) {
    // console.log(e)
  }

  loading.value = false

  return []
}

watch(() => selected.value, (value) => {
  if (value && model.value) {
    model.value.address = value.addressLabel
    model.value.address2 = ''
    model.value.suburb = value.borough || value.dependentLocality || ''
    model.value.city = value.city
    model.value.region = value.state
    model.value.postcode = value.postalCode
    model.value.country = value.country
  }
})
</script>
